import * as tslib_1 from "tslib";
import { Color } from './color';
import { Ease } from './ease';
import { Transition } from './transition';
import { TweenFrameAnimator } from './animator';
import { HtmlView } from './html';
export var ShadowBoxState;
(function (ShadowBoxState) {
    ShadowBoxState[ShadowBoxState["Hidden"] = 0] = "Hidden";
    ShadowBoxState[ShadowBoxState["Showing"] = 1] = "Showing";
    ShadowBoxState[ShadowBoxState["Visible"] = 2] = "Visible";
    ShadowBoxState[ShadowBoxState["Hiding"] = 3] = "Hiding";
})(ShadowBoxState || (ShadowBoxState = {}));
var ShadowBoxAnimator = (function (_super) {
    tslib_1.__extends(ShadowBoxAnimator, _super);
    function ShadowBoxAnimator(shadowBox, value, transition) {
        var _this = _super.call(this, value, transition) || this;
        _this.shadowBox = shadowBox;
        return _this;
    }
    ShadowBoxAnimator.prototype.update = function (value) {
        this.shadowBox.backgroundColor(this.shadowBox.shadowColor().alpha(value));
    };
    ShadowBoxAnimator.prototype.onEnd = function (value) {
        if (this.shadowBox.shadowBoxState === 1) {
            this.shadowBox.shadowBoxState = 2;
            this.shadowBox.didShow();
        }
        else if (this.shadowBox.shadowBoxState === 3) {
            this.shadowBox.shadowBoxState = 0;
            this.shadowBox.didHide();
        }
    };
    return ShadowBoxAnimator;
}(TweenFrameAnimator));
var ShadowBoxView = (function (_super) {
    tslib_1.__extends(ShadowBoxView, _super);
    function ShadowBoxView(node) {
        var _this = _super.call(this, node) || this;
        _this._shadowColor = Color.black();
        _this._shadowOpacity = 0.5;
        _this._shadowTransition = new Transition(250, Ease.quadOut).range(0);
        _this.shadowBoxState = 0;
        _this.shadowBoxAnimator = new ShadowBoxAnimator(_this, 0, _this._shadowTransition);
        return _this;
    }
    ShadowBoxView.prototype.isVisible = function () {
        return this.shadowBoxState === 2 ||
            this.shadowBoxState === 1;
    };
    ShadowBoxView.prototype.shadowColor = function (shadowColor) {
        if (shadowColor === undefined) {
            return this._shadowColor;
        }
        else {
            this._shadowColor = Color.fromAny(shadowColor);
            return this;
        }
    };
    ShadowBoxView.prototype.shadowOpacity = function (shadowOpacity) {
        if (shadowOpacity === undefined) {
            return this._shadowOpacity;
        }
        else {
            this._shadowOpacity = shadowOpacity;
            return this;
        }
    };
    ShadowBoxView.prototype.shadowTransition = function (shadowTransition) {
        if (shadowTransition === undefined) {
            return this._shadowTransition;
        }
        else {
            this._shadowTransition = Transition.fromAny(shadowTransition);
            return this;
        }
    };
    ShadowBoxView.prototype.show = function (trans) {
        if (this.shadowBoxState !== 2) {
            if (trans === undefined) {
                trans = this._shadowTransition;
            }
            else {
                trans = Transition.fromAny(trans || this._shadowTransition, 0);
            }
            this.willShow();
            this.shadowBoxState = 1;
            this.shadowBoxAnimator.set(this._shadowOpacity, trans);
        }
    };
    ShadowBoxView.prototype.hide = function (trans) {
        if (this.shadowBoxState !== 0) {
            if (trans === undefined) {
                trans = this._shadowTransition;
            }
            else {
                trans = Transition.fromAny(trans || this._shadowTransition, this._shadowOpacity);
            }
            this.willHide();
            this.shadowBoxState = 3;
            this.shadowBoxAnimator.set(0, trans);
        }
    };
    ShadowBoxView.prototype.willShow = function () {
    };
    ShadowBoxView.prototype.didShow = function () {
    };
    ShadowBoxView.prototype.willHide = function () {
    };
    ShadowBoxView.prototype.didHide = function () {
    };
    ShadowBoxView.create = function () {
        return new ShadowBoxView(document.createElement('div'))
            .className('shadow-box')
            .display('flex')
            .position('absolute')
            .top(0)
            .right(0)
            .bottom(0)
            .left(0)
            .pointerEvents('none')
            .zIndex(50);
    };
    return ShadowBoxView;
}(HtmlView));
export { ShadowBoxView };
//# sourceMappingURL=data:application/json;base64,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